import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { libraryRoot } from '../utils/hostMode';

const HelpPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const showBack = searchParams.get('from') !== 'login';

  return (
    <div style={{ position: 'relative', width: '100%', height: '100vh' }}>
      {showBack && (
        <button
          onClick={() => navigate(libraryRoot())}
          data-testid="help-back-btn"
          style={{
            position: 'fixed',
            top: 16,
            left: 16,
            zIndex: 9999,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            padding: '8px 16px',
            background: 'rgba(30,30,30,0.85)',
            backdropFilter: 'blur(8px)',
            border: '1px solid rgba(212,175,106,0.3)',
            borderRadius: 8,
            color: '#D4AF6A',
            cursor: 'pointer',
            fontSize: '0.82rem',
            fontWeight: 500,
            transition: 'background 0.2s',
          }}
          onMouseEnter={e => e.target.style.background = 'rgba(30,30,30,0.95)'}
          onMouseLeave={e => e.target.style.background = 'rgba(30,30,30,0.85)'}
        >
          <ChevronLeft size={16} /> Back to Knowledge Base
        </button>
      )}
      <iframe
        src="/help.html"
        title="IPMI Document Intelligence Help"
        style={{ width: '100%', height: '100%', border: 'none' }}
      />
    </div>
  );
};

export default HelpPage;
